import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { isNil, map } from 'ramda'
import { useTranslation } from 'react-i18next'
import { getOptions, getUserValue } from '../utils'
import { usePresetValue } from '../../utils/hooks'

const ExternalSelectQuestionnaire = ({ label, name, additionalInfo, showLabelAsPlaceholder, dependOnBooleanFldName }) => {
  const { t } = useTranslation()
  const [list, setList] = useState([])
  const [{
    data: { questionnaire },
    form,
    form: { accId },
    validation,
    validation: { tier },
    whitelabel: { questionnaireTier },
    user
  }, dispatch] = useStore()
  const questionnaireEnabled = !isNil(questionnaireTier)

  const [isVisible, setIsVisible] = useState(questionnaireEnabled && !dependOnBooleanFldName)
  const value = form[accId]?.[name]?.toString()
  const isValid = validation[`tier${tier}`]?.[accId]?.[name]
  const dependOnBooleanFldValue = form[accId][dependOnBooleanFldName]
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    if (questionnaire && questionnaire[name]?.length) {
      setList(getOptions(questionnaire[name]))
    }
  }, [questionnaire, name])

  useEffect(() => {
    if (!questionnaireEnabled) {
      resetField()
      return
    }
    if (!dependOnBooleanFldName) return
    if (dependOnBooleanFldValue === 1) {
      setIsVisible(true)
      dispatch({ type: 'addValidationFld', name })
    } else {
      resetField()
    }
  }, [questionnaireEnabled, dependOnBooleanFldName, dependOnBooleanFldValue, name])

  const presetValue = (value) => {
    const stringValue = value.toString()
    const isValid = stringValue.length > 0
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  usePresetValue(name, userValue, presetValue)

  const resetField = () => {
    dispatch({ type: 'removeValidationFld', name })
    dispatch({ type: 'removeFieldValue', name })
    setIsVisible(false)
  }

  const onChange = ({ target: { value, name } }) => {
    if (value?.length) {
      dispatch({ type: 'setExtFieldValue', name, value: +value })
    } else {
      dispatch({ type: 'setExtFieldValue', name, value: '' })
    }
    dispatch({ type: 'setValidationFld', name, value: value.length > 0 })
  }

  return isVisible ? (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={list}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  ) : null
}

const getExternalSelectQuestionnaireFields = map(currencyField => {
  const { i18n, name, required, order, dependOnBooleanFldName } = currencyField
  return (
    <ExternalSelectQuestionnaire
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      key={name}
      order={order}
      dependOnBooleanFldName={dependOnBooleanFldName}
    />
  )
})

export { ExternalSelectQuestionnaire, getExternalSelectQuestionnaireFields }
